import requests from "./httpService";

const ComanServices = {

    // App Policy
    getPolicy: async () => {
        return requests.get(`/content/policy`);
    },
    updatePolicy: async (body) => {
        return requests.put(`/content/policy`, body);
    },

    // About Us
    getAbout: async () => {
        return requests.get(`/content/about`);
    },
    addAbout: async (body) => {
        return requests.post(`/content/about`, body);
    },
    updateAbout: async (id, body) => {
        return requests.put(`/content/about/${id}`, body);
    },
    deleteAbout: async (id) => {
        return requests.delete(`/content/about/${id}`);
    },

    // Admin profile (self)
    profile: async () => {
        return requests.get(`/admin/profile`);
    },
    updateProfile: async (body) => {
        return requests.patch(`/admin/updateMe`, body);
    },
    changePassword: async (body) => {
        return requests.patch(`/admin/change-password`, body);
    },

    // Contact Info
    getContact: async () => {
        return requests.get(`/contact`);
    },
    updateContact: async (body) => {
        return requests.put(`/contact`, body);
    },

    // Dashboard
    getDashboard: async () => {
        return requests.get(`/admin/dashboard`);
    },

    // Page / Landing
    getLandingPage: async () => {
        return requests.get(`/content/page`);
    },
    updateLandingPage: async (body) => {
        return requests.put(`/content/page`, body);
    },

    // Blogs
    blog: async () => {
        return requests.get(`/blogs`);
    },
    getblogById: async (id) => {
        return requests.get(`/blogs/${id}`);
    },
    addBlog: async (body) => {
        return requests.post(`/blogs`, body);
    },
    updateBlog: async (id, body) => {
        return requests.put(`/blogs/${id}`, body);
    },
    deleteBlog: async (id) => {
        return requests.delete(`/blogs/${id}`);
    },

    // Trading Stocks
    stock: async () => {
        return requests.get(`/content/trading-stocks`);
    },
    stockById: async (id) => {
        return requests.get(`/content/trading-stocks/${id}`);
    },
    addStock: async (body) => {
        return requests.post(`/content/trading-stocks`, body);
    },
    updateStock: async (id, body) => {
        return requests.put(`/content/trading-stocks/${id}`, body);
    },
    deleteStock: async (id) => {
        return requests.delete(`/content/trading-stocks/${id}`);
    },

    // Day Settings
    getDay: async () => {
        return requests.get(`/content/day`);
    },
    updateDay: async (body) => {
        return requests.put(`/content/day`, body);
    },

    // Index % / Stock % (created once, then edited)
    getPercentage: async () => {
        return requests.get(`/content/percentage`);
    },
    createPercentage: async (body) => {
        return requests.post(`/content/percentage`, body);
    },
    updatePercentage: async (body) => {
        return requests.put(`/content/percentage`, body);
    },
}

export default ComanServices;
